// @NOTE: assumes jQuery is included by WP
const $ = jQuery

class header {
  constructor () {
    this.$window = $(window)

    this.$mobileNavButton     = $(".mobile-btn") 
    this.$closeMobileButton   = $(".js-close-menu-dropdown")
    this.$mobileNavBg         = $(".mobile-nav-bg-curtain")
    this.$siteHeader          = $(".header-primary")
    this.$closeRibbon         = $(".js-close-ribbon")
    this.$self                = this

    this.$mobileNavButton.click(function () { 
      $(".navigation").addClass('menu-open')
      $(".mobile-nav-bg-curtain").addClass('menu-open')
    }); 

    this.$closeMobileButton.click(function () { 
      $(".navigation").removeClass('menu-open') 
      $(".mobile-nav-bg-curtain").removeClass('menu-open')
    }); 

    this.$mobileNavBg.click(function () { 
      $(".navigation").removeClass('menu-open') 
      $(".mobile-nav-bg-curtain").removeClass('menu-open')
    });

    this.$closeRibbon.click( () => {
      $(".ribbon").slideUp(400);
      var date = new Date();
      var minutesToShowRibbonAgain = window.minutesToShowRibbonAgain !== undefined ? window.minutesToShowRibbonAgain : 15;

      if (minutesToShowRibbonAgain == 0) {
        return
      }

      date.setTime(date.getTime() + (minutesToShowRibbonAgain * 60 * 1000));
      document.cookie = "wordpress_hide_ribbon=yes; expires="+ date.toUTCString() +"; path=/;";
    }); 

  }

}

export default header


// WEBPACK FOOTER //
// ./src/js/custom/header/header.js